export default "/kiban/_next/static/images/04_4L_1-2-1_withBH_stack-f8c2fac849baa067dac4eb12c7e82ffb.png";